import Backbone from 'backbone';
import $ from 'jquery';
import { MagnificPopup } from '../../../Assets/javascripts/common/dynamic-imports/MagnificPopup';

const magnificPopup = new MagnificPopup();

export default Backbone.View.extend({
  initialize: function () {
    var self = this;
    this.isEditing = false;
    this.orderId = this.$el.attr('data-order-id');
    this.orderReference = this.$el.attr('data-order-reference');
    this.$cancelButton = this.$('.js-Order-cancel');
    this.$cancelBackButton = this.$('.js-Order-cancelBack');
    this.$cancelStatus = this.$('.js-Order-cancelStatus');
    this.$userRef = this.$('.js-order-userref');
    this.$form = $('#formSearchOrderId');
    this.$carousel = this.$('.js-Carousel');
    this.carouselId = this.$carousel.attr('data-carousel-id');
    this.isTacitAgreementOrder = this.$('.ma-OrderDetailTab-sectionItem').data('istacitrenewal') == 'True';
    this.tacitAgreementCancellationUrl = $('#urlSettings').data('tacitrenewalcancellationurl');
    this.$incidentBanner = this.$('.js-order-incident');
    this.$tacitAgreementRefund = this.$('.js-Order-cancelTacitRenewal');
    this.isCaixaMultiple = this.$('.js-Order-cancel').data('iscaixamultiple') === 'True';
    this.hasFreeArticle = this.$('.js-Order-cancel').data('hasfreearticle') === 'True';
    this.hasFreeArticleMultiparcels = this.$('.js-Order-cancel').data('hasfreearticlemultiparcels') === 'True';

    if ($('.openPopinCancelConfirmation').length) {
      $('.openPopinCancelConfirmation').popinManager({
        targetContent: '#CancelConfirmationPopin',
      });
    }
    this.$('.js-Order-tracking').each(function (index, element) {
      var $element = $(element);

      var trackingTitle = $element.attr('data-tracking-title');
      var trackingUrl = $element.find('a').attr('href');
      var trackingLink =
        '<a class="btn btn-block transparent2-btn" href="' + trackingUrl + '">' + trackingTitle + '</a>';

      if (trackingUrl) {
        $element.html('').html(trackingLink);
      }
    });
  },

  events: {
    'click .js-Order-cancel,.js-Order-cancelTacitRenewal': 'cancel',
    'click .js-Order-cancelConfirm': 'confirm',
    'click .js-Order-cancelBack': 'back',
  },

  cancel: function () {
    this.isEditing = true;
    this.render();
  },

  cancelMultipleCaixa: function () {
    magnificPopup.open({
      items: {
        src: $('.js-caixaMultipleCancelPopin'),
        type: 'inline',
      },
    });
  },

  cancelFreeArticle: function () {
    magnificPopup.open({
      items: {
        src: $('.js-freeOrderCancelPopin'),
        type: 'inline',
      },
    });
  },

  confirm: function (event) {
    event.preventDefault();

    if (this.isCaixaMultiple || this.hasFreeArticle) {
      var currentParcel = event.currentTarget.closest('.ma-OrderTable-historyWrap');
      var allCheckboxes = $(currentParcel).find("[name='ItemDetailReferencesToRemove']");

      if (allCheckboxes.length === allCheckboxes.filter(':checked').length && !this.hasFreeArticleMultiparcels) {
        this.$form.submit();
      } else {
        if (this.hasFreeArticle) this.cancelFreeArticle();
        else {
          this.cancelMultipleCaixa();
        }
      }
    } else if (this.isTacitAgreementOrder) {
      var $item = this.$el.find("[name='ItemDetailReferencesToRemove']");
      if ($item.is(':checked')) {
        var orderDetailReference = $item.val();
        var data = { orderReference: this.orderReference, orderDetailReference: orderDetailReference };
        var self = this;
        this.PostData(
          this.tacitAgreementCancellationUrl,
          data,
          function (results) {
            self.$incidentBanner.removeClass('hide');
            self.$tacitAgreementRefund.remove();
            self.back(event);
            var $incidentDetail = $('.js-Order-cancelTacitRenewal-detail');
            var incidentUrl = $incidentDetail.attr('href').replace('%7B0%7D', results.incidentUserReference);
            $incidentDetail.attr('href', incidentUrl);
            $('.openPopinCancelConfirmation').trigger('click');
          },
          function () {}
        );
      }
    } else {
      this.$form.submit();
    }
  },
  back: function (event) {
    event.preventDefault();

    this.isEditing = false;
    this.render();
  },

  render: function () {
    if (this.isEditing) {
      this.isEditing = false;
      this.$el.addClass('ma-CancelProduct');
      this.$userRef.removeAttr('disabled');
      this.$cancelStatus.prop('value', 'CancelOff');
      this.$('.js-Carousel-next, .js-Carousel-prev').hide();
    } else {
      this.isEditing = true;
      this.$userRef.prop('disabled', true);
      this.$el.removeClass('ma-CancelProduct');
      this.$cancelStatus.prop('value', 'CancelOn');
      this.$('.js-Carousel-next, .js-Carousel-prev').show();
    }
  },

  PostData: function (url, data, successCallback, errorCallback) {
    $.ajax(url, {
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: function (data) {
        if (data.result) {
          successCallback.call(self, data);
        } else {
          errorCallback.apply(self, data.message);
        }
      },
      error: function (data) {
        errorCallback.apply(self, ['Une erreur est survenue']);
      },
    });
  },
});
